export default (theme) => ({
  root: {},
  tableRow: {
    backgroundColor: theme.palette.common.white,
    cursor: 'pointer',

    '&.Mui-selected td': {
      borderBottom: `3px solid #889098 `,
    },
  },
});
